module.exports = "/packs/course-small-design-exercise-53f6ce9f170d63ab25a7be7f1d8e44da.png";